module.exports = __webpack_public_path__ + "img/good.343bd656.svg";